import { readCookie } from '../../../../util/dom/cookie';
import { REGION_COOKIE_KEY } from './constants';

export default {
    userRegion: readCookie(REGION_COOKIE_KEY),
};
